import React, { useEffect, } from "react"
import { Link, graphql} from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import Seo from "./seo"
import Layout from './layout' 


const MdxPage = ({data, pageContext, location }) => {
  const post = data.mdx
  const siteTitle = data.site.siteMetadata.title
  const { previous, next } = pageContext


  return (
<Layout location={location} title={siteTitle}>
    <Seo
      title={post.frontmatter.title}
      description={post.frontmatter.description || post.excerpt}
    />

      <div className="w-100 center flex flex-column flex-row-m  bb  b-black-05" >
          <div className="w-100">
            {next && (
              <Link className="flex link black-700" to={`/${next.slug}`} rel="next">
                <div className="f7 fw3 pv05 ph1 w-100 ">←  {next.frontmatter.title}</div>
              </Link>
            )}
          </div>
          <div className="w-100 tr">
            {previous && (
              <Link className="flex link black-700" to={`/${previous.slug}`} rel="prev">
                <div className="f7 fw3 pv05 ph1 w-100">{previous.frontmatter.title} →</div>
              </Link>
            )}
          </div>
      </div>

    
   <div id="contentarticle" className="bg-white cf animate-03 fadeIn"  >
        <MDXRenderer
          remoteImages={post.frontmatter.embeddedImagesRemote}
          localImages={post.frontmatter.embeddedImagesLocal}
        >
          {post.body}
        </MDXRenderer>
  </div>

  <div className="w-100 center flex flex-column flex-row-m  bb  b-black-05" >
          <div className="w-100">
            {next && (
              <Link className="flex link black-700" to={`/${next.slug}`} rel="next">
                <div className="f7 fw3 pv05 ph1 w-100 ">←  {next.frontmatter.title}</div>
              </Link>
            )}
          </div>
          <div className="w-100 tr">
            {previous && (
              <Link className="flex link black-700" to={`/${previous.slug}`} rel="prev">
                <div className="f7 fw3 pv05 ph1 w-100">{previous.frontmatter.title} →</div>
              </Link>
            )}
          </div>
      </div>



</Layout>
  );
};

export const query = graphql`
  query($id: String) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        description
        order
        embeddedImagesRemote {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        embeddedImagesLocal {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
      excerpt(pruneLength: 160)
      body
    }
  }
`;

export default MdxPage;
